<template>
  <v-container grid-list-md>
    <v-slide-y-transition mode="out-in">
      <v-flex md8 offset-md2>
        <v-card>
          <v-toolbar flat color="grey lighten-3">
            <v-btn icon @click="close()">
              <v-icon>arrow_back</v-icon>
            </v-btn>
            <v-toolbar-title>Stats</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-layout row wrap="">
              <v-flex xs12 class="text-xs-center">
                <p>No stats are available.</p>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-slide-y-transition>
  </v-container>
</template>

<script>
import RestService from '../services/RestService';
import * as Sentry from '@sentry/browser';

const service = new RestService();

export default {
  name: 'ActionStats',
  props: {
    actionId: String
  },
  data() {
    return {
      action: {}
    };
  },
  methods: {
    close() {
      this.$router.go(-1);
    },
    save() {
      this.$router.go(-1);
    }
  },
  created() {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
